export default __webpack_public_path__ + "static/media/wellcome-bg.b067e22a.svg";